import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpinnerLoader',
    props: {
        noMargin: { type: Boolean, default: false }
    },
    setup(__props) {
        // Components
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["rc-loader", { 'rc-noMargin': __props.noMargin }])
            }, [
                _createVNode(SvgIcon, {
                    icon: "loader-spin",
                    width: "5rem",
                    height: "5rem",
                    color: "var(--p-100)"
                })
            ], 2));
        };
    }
});
